var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-141.491 0-256 114.497-256 256 0 141.491 114.497 256 256 256 141.491 0 256-114.497 256-256 0-141.491-114.497-256-256-256zm189.302 271h36.188c-3.362 51.045-23.739 97.511-55.509 133.767l-15.518-15.517c-5.857-5.859-15.355-5.857-21.213 0-5.858 5.858-5.858 15.355 0 21.213l15.518 15.517c-36.256 31.771-82.723 52.148-133.768 55.51v-26.188c0-8.284-6.716-15-15-15s-15 6.716-15 15v26.188c-51.045-3.362-97.511-23.739-133.767-55.509l15.517-15.518c5.858-5.857 5.858-15.355 0-21.213-5.857-5.857-15.355-5.857-21.213 0l-15.517 15.517c-31.771-36.255-52.148-82.722-55.51-133.767h26.188c8.284 0 15-6.716 15-15s-6.716-15-15-15h-26.188c3.362-51.045 23.739-97.511 55.509-133.767l15.517 15.517c5.858 5.858 15.355 5.858 21.213 0 5.857-5.857 5.857-15.355 0-21.213l-15.517-15.517c36.256-31.771 82.723-52.148 133.768-55.51v26.188c0 8.284 6.716 15 15 15s15-6.716 15-15v-26.188c51.045 3.362 97.511 23.739 133.767 55.509l-15.517 15.518c-5.858 5.858-5.858 15.355 0 21.213 5.856 5.858 15.354 5.859 21.213 0l15.517-15.518c31.771 36.256 52.148 82.723 55.51 133.768h-36.188c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.651 241h-79.651v-124.302c0-8.284-6.716-15-15-15s-15 6.716-15 15v139.302c0 8.284 6.716 15 15 15h94.651c8.284 0 15-6.716 15-15s-6.715-15-15-15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.6af24e7a504c8fdc93ebf8ef31309602.svg";
export { ForwardRef as ReactComponent };